import React from "react"
import styled from "styled-components"
import { useBreakpoints } from "src/lib/hooks/use-breakpoints"
import { Text } from "components/text/Text"
import { colors } from "src/styles/colors"
import PERSON from "assets/icons/person.svg"
import DATE from "assets/icons/date.svg"
import ImgWrapper from "components/image/ImageWrapper"
import { Link } from "gatsby"

type Props = {
  author: { name: string }
  createdAt: string
  subtitle: { subtitle: string }
  title: string
  outsideImage: any
  slug: string
}

const Container = styled(Link)<any>`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  width: ${({ minTablet }) => (minTablet ? "360px" : "100%")};
  min-height: 475px;
`
const Content = styled.div<any>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  & .overflow,
  .overflow__p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  & .overflow__p {
    -webkit-line-clamp: 4; /* number of lines to show */
  }
  & .after {
    position: relative;
    &:after {
      position: absolute;
      content: "";
      bottom: -3px;
      left: 0;
      width: 44px;
      height: 1px;
      background-color: ${colors.pink};
    }
  }
`

const IconsWrapper = styled.div<any>`
  display: flex;
  padding-left: 4px;
  margin-bottom: 10px;
  margin-top: ${({ minTablet }) => (minTablet ? "10px" : "20px")};
  & span {
    display: flex !important;
    align-items: center;
  }
  & img {
    margin-right: 5px;
  }
`

export const ArticleElement: React.FC<Props> = ({
  author: { name },
  createdAt,
  subtitle: { subtitle },
  title,
  outsideImage,
  slug,
}) => {
  const { minTablet } = useBreakpoints()
  return (
    <Container className="article" to={`/${slug}/`} minTablet={minTablet}>
      <ImgWrapper
        img={outsideImage}
        width={minTablet ? 360 : 0}
        style={{ marginBottom: 18 }}
      />
      <Content>
        <IconsWrapper minTablet={minTablet}>
          <Text color={colors.gray11} textAlign="center" size={14}>
            <img src={PERSON} alt="person" loading="lazy" />
            {name}
          </Text>
          <Text
            color={colors.gray11}
            textAlign="center"
            size={14}
            style={{ marginLeft: 23 }}
          >
            <img src={DATE} alt="date" loading="lazy" />
            {createdAt}
          </Text>
        </IconsWrapper>
        <Text
          className="overflow"
          color={colors.blueGray}
          size={22}
          fontWeight={600}
          style={{ marginBottom: 15 }}
        >
          {title}
        </Text>
        <Text
          className="overflow__p"
          color={colors.black}
          size={14}
          style={{ marginBottom: 15 }}
        >
          {subtitle}
        </Text>
        <Text className="after" color={colors.pink} size={14}>
          Lesen
        </Text>
      </Content>
    </Container>
  )
}
